module.exports = __webpack_public_path__ + "static/media/coupon_not_available.4af1dcdc.png";